import NextArrow from '@/app/components/questionnaireV2/icons/next-arrow';
import { ThreeDotLoader } from '../../../loader/loader';

export interface BaseNextButtonProps {
  onNext: () => void;
  variant?: 'primary' | 'action-light';
  text?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  loading?: boolean;
}

export function BaseNextButton({ onNext, variant = 'primary', text, style, disabled = false, loading = false }: BaseNextButtonProps) {
  const className = variant === 'action-light' ? 'btn-action btn-action-light' : 'btn-primary';
  const buttonText = text ? text : 'Next';

  return (
    <button
      type="button"
      onClick={onNext}
      className={className}
      style={style}
      disabled={disabled || loading}
      aria-label={buttonText}
    >
      {loading ? (
        <ThreeDotLoader />
      ) : (
        <>
          <span>{buttonText}</span>
          <NextArrow />
        </>
      )}
    </button>
  );
}